import { z } from "zod";
import { Multiplayer } from "./lib/multiplayer";
import { PocketBaseProvider } from "./lib/multiplayer/signaling/PocketBaseProvider";
import { pocketbase } from "./services/pocketbase";
// import { WebSocketProvider } from "./lib/multiplayer/signaling/WebSocketProvider";

// Create a signaling provider instance directly
const signalingProvider = new PocketBaseProvider(pocketbase());

// If you want to use WebSocket provider instead, comment out the PocketBase provider above 
// and uncomment this line:
// const signalingProvider = new WebSocketProvider();

export const playerProfile = z.object({
	id: z.string(),
	name: z.string(),
	avatar: z.string().optional(),
});
export type PlayerProfile = z.infer<typeof playerProfile>;

// Pass the signaling provider to the Multiplayer instance
export const multiplayer = new Multiplayer(signalingProvider, {})
	.packetType("player:register", playerProfile)
	.packetType("player:list", z.array(playerProfile))
	.packetType("ping", z.object({
		time: z.number(),
	}))
	.packetType("pong", z.object({
		time: z.number(),
	}))
	.packetType('startGame', z.object({}))
	.packetType('onClick', z.object({
		objectId: z.string(),
	}))
	.packetType("objectSnapshot", z.object({
		objectId: z.string(),
		position: z.object({
			x: z.number(),
			y: z.number(),
			z: z.number(),
		}),
	}))
